// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import SvgLarge from '@rhg/../public/_n/images/icons/checkmark-large.svg';
import SvgSmall from '@rhg/../public/_n/images/icons/checkmark-small.svg';
import { useMemo } from 'react';

export interface CheckmarkProps extends SvgIconProps {
    size: 'small' | 'large';
}

export const Checkmark = ({ size, ...props }: CheckmarkProps) => {
    const component = useMemo(() => {
        const isSmall = size === 'small';

        return isSmall ? SvgSmall : SvgLarge;
    }, [size]);

    return (
        <SvgIcon
            data-testid="CheckIcon"
            component={component}
            inheritViewBox
            {...props}
        />
    );
};
